import cn from 'classnames/bind'
import { isValueZero } from './isValueZero'
import styles from './EncashmentsCount.module.scss'


const cx = cn.bind(styles)

type Props = {
  value: number
}

export const EncashmentsCount = ({ value }: Props) => {
  const zero = isValueZero(value)
  return (
    <span className={cx(styles.root, { zero })}>
      {value === null ? '—' : value}
    </span>
  )
}
